/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export function prepareSavedFilesForPond (files) {
  if (!Array.isArray(files)) {
    if (typeof files !== 'string' || files.length === 0) {
      return []
    }

    files = [files]
  }

  const pondFiles = []

  files.forEach((file) => {
    pondFiles.push({
      source: file,
      options: {
        type: 'local'
      }
    })
  })

  return pondFiles
}
